import './index.less'

const QDParagraph = ({ paragraph, style, className }) => {
  return (
    <p className={`qd-paragraph-wrapper ${className}`} style={style}>{paragraph}</p>
  )
}

export default QDParagraph